import React from 'react'
import '../css/rainbow.css'
import rainout from '../Images/rainout.png'
import rainin from '../Images/rainin.png'
import raingoogle from '../Images/raingoogle.png'
import learnmore from '../Images/learnmore.png'
import aizrelogo from '../Images/aizrelogo.png'
import { Link } from 'react-router-dom';

function Rainbow() {
  return (
    <div className="rainbowMain">
      <div className="hSHeading">
        <h1>Ascend with our Creativity</h1>
      </div>
      
      <div className="cardsContainer">
        {/* First Card - Creative Tokens */}
        <div className="cardWrapper creativeCard">
        {/* <img src={rainout} alt="rainout"/> */}
          <div className="cardBackground">
            <div className="glowEffect"></div>
            {/* Logo and Brand Section */}
            <div className="cardContent">
              <div className="cardBrand">
                <div className="cardLogo">
                  <img src={raingoogle} alt="Creative Tokens Logo" />
                </div>
                <div className="brandText">
                  <h2>CREATIVE</h2>
                  <h2>TOKENS</h2>
                </div>
              </div>
              
              {/* Description section */}
              <div className="cardDescription">
                <p>Go with our creativity in design or ideation, Share a brief or a problem and its done!</p>
              </div>
              
              {/* Buttons section */}
              <div className="cardButtons">

                <Link to="/creative-tokens" className="cardButton outlineButton">
                <span className="buttonIcon">→</span>
                <span>Learn More</span>
                </Link>

                <Link to="/profile" className="cardButton filledButton">
                  <span className="buttonIcon">→</span>
                  <span>Sign up</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        {/* Second Card - AIZRE */}
        <div className="cardWrapper aizreCard">
          <div className="cardBackground">
            <a href='https://aizre.com/' target='_blank'>
            <div className="glowEffect"></div>
            <div className="gridLines"></div>
            
            {/* Logo and Brand Section */}
            <div className="cardContent">
              <div className="aizreBrand">
                <img src={aizrelogo}/>
                <p className="aizreSubheading">AI Gen models</p>
              </div>
              
              {/* Tagline */}
              <div className="aizreTagline">
                <p>Powerful & Private</p>
                <p>made to scale</p>
              </div>
            </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Rainbow
